// Kleine Leadsuche zum Zuordnen (Reiter Emails der Inbox): ein Feld, darunter die Treffer aus der Suche (Leads und Kontakte).
import { useEffect, useRef, useState } from "react";
import { sucheApi, type SuchTreffer } from "../../api";
import { StatusPille } from "../Bausteine";
import "./nachrichten.css";

interface Props {
  /** Vorbelegung, z. B. der Absendername oder die Firma aus der Adresse */
  start?: string;
  onWahl: (t: SuchTreffer) => void;
  onAbbrechen: () => void;
}

export function LeadWahl({ start = "", onWahl, onAbbrechen }: Props) {
  const [q, setQ] = useState(start);
  const [treffer, setTreffer] = useState<SuchTreffer[] | null>(null);
  const [aktiv, setAktiv] = useState(0);
  const feld = useRef<HTMLInputElement>(null);

  useEffect(() => {
    feld.current?.focus();
    feld.current?.select();
  }, []);

  useEffect(() => {
    const wort = q.trim();
    if (wort.length < 2) {
      setTreffer(null);
      return;
    }
    const abbruch = new AbortController();
    const t = window.setTimeout(() => {
      sucheApi
        .suchen(wort, 8, abbruch.signal)
        .then((r) => {
          const gesehen = new Set<string>();
          setTreffer(r.data.filter((x) => (gesehen.has(x.lead_id) ? false : (gesehen.add(x.lead_id), true))));
          setAktiv(0);
        })
        .catch(() => !abbruch.signal.aborted && setTreffer([]));
    }, 220);
    return () => {
      window.clearTimeout(t);
      abbruch.abort();
    };
  }, [q]);

  return (
    <div className="lead-wahl" onClick={(e) => e.stopPropagation()}>
      <input
        ref={feld}
        className="eingabe eingabe--klein lead-wahl__feld"
        value={q}
        placeholder="Lead oder Kontakt suchen …"
        aria-label="Lead oder Kontakt suchen"
        onChange={(e) => setQ(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            e.preventDefault();
            e.stopPropagation();
            onAbbrechen();
          } else if (e.key === "ArrowDown" && treffer?.length) {
            e.preventDefault();
            setAktiv((a) => Math.min(a + 1, treffer.length - 1));
          } else if (e.key === "ArrowUp") {
            e.preventDefault();
            setAktiv((a) => Math.max(a - 1, 0));
          } else if (e.key === "Enter" && treffer?.[aktiv]) {
            e.preventDefault();
            onWahl(treffer[aktiv]);
          }
        }}
      />
      {treffer ? (
        treffer.length ? (
          <ul className="lead-wahl__liste" role="listbox">
            {treffer.map((t, i) => (
              <li key={`${t.lead_id}${t.contact_id ?? ""}`} role="option" aria-selected={i === aktiv}>
                <button type="button" className={`lead-wahl__treffer${i === aktiv ? " lead-wahl__treffer--an" : ""}`} onMouseEnter={() => setAktiv(i)} onClick={() => onWahl(t)}>
                  <span className="lead-wahl__titel">{t.title}</span>
                  {t.subtitle && t.subtitle !== t.status_label ? <span className="lead-wahl__sub">{t.subtitle}</span> : null}
                  {t.status_label ? <StatusPille label={t.status_label} klein schlicht /> : null}
                </button>
              </li>
            ))}
          </ul>
        ) : (
          <div className="lead-wahl__leer leise">Kein Treffer.</div>
        )
      ) : null}
    </div>
  );
}
